export default __webpack_public_path__ + "static/media/laptop-mockup.61bd4be5.png";